export const COOKIE_POLICY_VERSION = "2026-08-23";
